import {
  Create,
  NumberInput,
  SimpleForm,
  SelectInput,
  TextInput,
  DateTimeInput,
  BooleanInput,
} from "react-admin";

import { FileInputSingle } from "../fileInput/fileInput";
import { FileInputSingleLarge } from "../fileinputs/eventFileUpload";

export const StoryCreate = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="description" />
        <SelectInput
          source="type"
          choices={[
            { id: "Video", name: "Video" },
            { id: "Image", name: "Image" },
          ]}
        />
        {/* <TextInput source="thumbnail" />
        <TextInput source="link" /> */}
        {/* <FileInputSingle source="thumbnail" title="Upload Thumbnail" /> */}
        <FileInputSingleLarge source="thumbnail" title="Upload Thumbnail" />
        <FileInputSingleLarge source="link" title="Upload Link" />
        <DateTimeInput source="startTimestamp" />
        <DateTimeInput source="endTimestamp" />
        <NumberInput source="duration" />
        <BooleanInput source="isPromotion" />
        {/* <FileInput resourceField="image" type="string" /> */}
      </SimpleForm>
    </Create>
  );
};
